import { FC, useEffect } from 'react';
import { AuthXService } from '@brg/auth';
import { Spinner } from '@brg/controls';
import { SpinnerWrapper } from './styled';
import LoadingPage from 'shared/pages/loading/LoadingPage';

export const LogoutView: FC = () => {
    useEffect(() => {
        AuthXService.createUserManager().signoutRedirectCallback().then(data => {
            //@ts-ignore
            const returnUrl = data?.userState?.returnUrl ?? window.location.origin;
            window.location.href = `https://auth.design.hse.ru/account/logout?returnUrl=${encodeURI(returnUrl)}`;
        });
    }, []);
    return <div>
        <LoadingPage redirecting/>
        <SpinnerWrapper>
            <Spinner size={100} color='silver' width={1.5} />
        </SpinnerWrapper>
    </div>;
};
import { FC, useEffect } from 'react';
import { AuthXService } from '@brg/auth';
import { Spinner } from '@brg/controls';
import { SpinnerWrapper } from './styled';
import LoadingPage from 'shared/pages/loading/LoadingPage';

export const LogoutView: FC = () => {
    useEffect(() => {
        AuthXService.createUserManager().signoutRedirectCallback().then(data => {
            //@ts-ignore
            const returnUrl = data?.userState?.returnUrl ?? window.location.origin;
            window.location.href = `https://auth.design.hse.ru/account/logout?returnUrl=${encodeURI(returnUrl)}`;
        });
    }, []);
    return <div>
        <LoadingPage redirecting/>
        <SpinnerWrapper>
            <Spinner size={100} color='silver' width={1.5} />
        </SpinnerWrapper>
    </div>;
};
